/**
 * @file asset-url.ts
 * @description Masks Contentstack asset-CDN hosts in CMS payloads so rendered markup stays same-origin.
 */

// Matches any region's asset-delivery host (e.g. azure-na-assets.contentstack.com), mirroring the
// image-host pattern in lib/next-config/plugins/images.ts. Deliberately excludes "-images." hosts —
// those are already proxied same-origin via next/image's /_next/image route.
const CONTENTSTACK_ASSET_HOST = /https?:\/\/[a-z0-9-]*-assets\.contentstack\.com/gi;

// Strips the Contentstack asset-CDN origin from every URL found anywhere in a CMS payload (file
// fields, rich text HTML, nested references), leaving a root-relative path the Launch edge rewrite
// (/v3/assets/:path*) resolves back to the real asset. Call once, right after the SDK response
// comes back, so no render site has to remember to do this itself.
export function maskAssetHosts<T>(data: T): T {
  if (data == null) return data;
  return JSON.parse(JSON.stringify(data).replace(CONTENTSTACK_ASSET_HOST, '')) as T;
}
